<template>
    <b-card
        v-if="attributeId"
        title="Toplu özellik atama"
    >
        <p>Seçilen eksik zorunlu özellik, yalnızca seçtiğiniz ve mevcut filtrelere uyan ürünlere atanır. Değerin kendi kategorisinde bulunmadığı ürünler atlanır.</p>
        <b-form @submit.prevent="assign">
            <b-form-group
                label="Atanacak değer"
                label-for="bulk-attribute-value"
            >
                <v-select
                    v-model="value"
                    input-id="bulk-attribute-value"
                    :options="bulkValues"
                    label="name"
                    :loading="loading"
                    :disabled="loading || saving"
                    placeholder="Değer arayın ve seçin"
                >
                    <template #no-options>
                        Uygun değer bulunamadı.
                    </template>
                </v-select>
            </b-form-group>
            <b-button
                type="submit"
                variant="primary"
                :disabled="!value || loading || saving || !listReady || !selectedCount"
            >
                {{ saving ? 'Atanıyor…' : `Seçilenlere ata (${selectedCount})` }}
            </b-button>
            <span
                v-if="loading"
                class="ml-1"
                role="status"
            >Değerler yükleniyor…</span>
        </b-form>
        <b-alert
            :show="!!error"
            variant="danger"
            class="mt-1 mb-0"
        >
            {{ error }}
            <b-button
                v-if="valuesFailed"
                size="sm"
                :disabled="loading"
                @click="loadValues"
            >
                Tekrar dene
            </b-button>
        </b-alert>
        <b-alert
            :show="!!success"
            variant="success"
            class="mt-1 mb-0"
        >
            {{ success }}
        </b-alert>
    </b-card>
</template>
<script>
    import { mapState, mapGetters } from 'vuex'
    import {
        BCard, BForm, BFormGroup, BButton, BAlert,
    } from 'bootstrap-vue'
    import VSelect from 'vue-select'
    import { errorMessage } from '@/store/v2/trendyol/management'

    export default {
        components: {
            BCard, BForm, BFormGroup, BButton, BAlert, VSelect,
        },
        data: () => ({
            value: null,
            loading: false,
            saving: false,
            error: '',
            success: '',
            valuesFailed: false,
            version: 0,
        }),
        computed: {
            ...mapState('tyManagement', ['filters', 'bulkValues', 'listReady']),
            ...mapGetters('tyManagement', ['selectedCount']),
            attributeId() { return this.filters.missing_required_attribute_id },
        },
        watch: {
            attributeId: {
                immediate: true,
                handler() {
                    this.value = null
                    this.error = ''
                    this.success = ''
                    this.loadValues()
                },
            },
        },
        beforeDestroy() { this.version += 1 },
        methods: {
            async loadValues() {
                this.version += 1
                const { version, attributeId } = this
                this.loading = false
                this.valuesFailed = false
                if (!attributeId) return
                this.loading = true
                this.error = ''
                try {
                    await this.$store.dispatch('tyManagement/loadBulkValues', attributeId)
                } catch (error) {
                    if (version === this.version) {
                        this.error = errorMessage(error)
                        this.valuesFailed = true
                    }
                } finally {
                    if (version === this.version) this.loading = false
                }
            },
            async assign() {
                if (!this.value || this.loading || this.saving || !this.listReady || !this.selectedCount) return
                const { version } = this
                const filters = { ...this.filters }
                this.saving = true
                this.error = ''
                this.success = ''
                try {
                    const result = await this.$store.dispatch('tyManagement/bulkAssign', { filters, valueName: this.value.name })
                    if (version === this.version) this.success = `${result.assigned} ürüne atandı. ${result.skipped} ürün atlandı.`
                    this.$emit('assigned')
                } catch (error) {
                    if (version === this.version) this.error = errorMessage(error)
                } finally {
                    this.saving = false
                }
            },
        },
    }
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
